import "core-js/modules/es.array.push.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.for-each.js";
// 弹窗组件批量注册
const names = [];
const popUp = {};
const files = require.context('@/components/map/popup', true, /\.vue$/);
files.keys().forEach(key => {
  let name = key.split('/').pop().replace(/\.\w+$/, '');
  if (name === 'index') return;
  names.push(name);
  popUp[name] = files(key).default || files(key);
});
export default {
  data() {
    return {
      names: names
    };
  },
  components: popUp,
  props: ['modeltype']
};